import { CdkMenuTrigger } from '@angular/cdk/menu';
import { AfterViewInit, Component, ContentChild, ElementRef, Input, Self, SimpleChanges, TemplateRef, ViewChild, input, output, viewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl } from '@angular/forms';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { ChildrenAnimation, fadeUpDown } from '@ex/module/shared/animations/allAnimations';

export enum ReturnedDataShape {
  Key = 'key',
  Full = 'full'
}
@Component({
  selector: 'zen-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  animations: [fadeUpDown, ChildrenAnimation],
  standalone: false
})
export class SelectComponent extends BaseComponent implements ControlValueAccessor, AfterViewInit {
  readonly iTrigger = viewChild(CdkMenuTrigger);
  readonly searchBox = viewChild<ElementRef<HTMLInputElement>>('searchBox');
  @ViewChild('area') area!: ElementRef;
  // @ViewChild('searchBox') searchBox!: ElementRef;
  list: any[] = [] as any;
  @ContentChild('valueTemplate') valueTemplate!: TemplateRef<any>;
  @ContentChild('valuesTemplate') valuesTemplate!: TemplateRef<any>;
  @ContentChild('optionTemplate') optionTemplate!: TemplateRef<any>;
  readonly trigger = viewChild<ElementRef>('trigger');
  selected: any;
  tempList: any;
  readonly max = input<number>(0);
  readonly invalid = input(false);
  readonly objectShape = input<ReturnedDataShape>(ReturnedDataShape.Key, { alias: "shape" });
  readonly submitted = input(false);
  readonly triggeAarea = input<boolean>(true, { alias: "trigger" });
  menuWidth: any;
  readonly reset = input(false);
  @Input('menuOpen') set menuOpen(condition: any) { }
  readonly searchText = input('Search...');
  @Input() multiple = false;
  readonly nullable = input(false);
  readonly labelPosition = input<any>();
  @Input() label!: string;
  readonly required = input<boolean>(false);
  readonly language = input('EN');
  @Input() placeholder: string = 'zen-select-placeholder';
  readonly key = input('key');
  readonly color = input('app');
  readonly showAll = input<boolean>(false);

  readonly selectionChange = output<any>();
  readonly openChange = output<any>();
  @Input('options') set ops(options: any) {
    this.list = options;
    this.tempList = options;
  }
  @Input() disabled: boolean = false;
  @Input() searchFields: string[] = []
  onChange: any = () => { };
  onTouch: any = () => { };
  searchValue: string = '';
  constructor(@Self() public ngControl: NgControl) {
    super();
    if (ngControl)
      ngControl.valueAccessor = this;
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.menuWidth = this.area?.nativeElement?.clientWidth;
    }, 100);
  }

  ngOnInit(): void {


  }



  ngOnChanges(changes: SimpleChanges): void {

  }

  writeValue(key: any) {
    this.selected = key;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    if (this.disabled)
      return;
    setTimeout(() => {
      this.disabled = isDisabled;
    }, 300);

  }

  clear(e: any) {
    e.stopPropagation();
    this.multiple ? this.selected = [] : this.selected = '';
    this.onChange(this.selected);
    this.selectionChange.emit(this.selected);
  }

  handleSelection(option: any) {
    //console.log(option);

    if (!this.multiple) {
      this.selected = option;
      const data = this.objectShape() == ReturnedDataShape.Key ? option : this.getValue(option)
      this.onChange(data);
      this.iTrigger()?.close();
      this.selectionChange.emit(data);

    }
    else {
      if (!this.selected)
        this.selected = [];
      if (this.selected?.find((s: any) => s == option))
        this.selected.splice(this.selected.indexOf(option), 1);
      else {
        if (this.max() && this.selected?.length >= this.max())
          return;
        this.selected.push(option);
      }

      const data = this.objectShape() == ReturnedDataShape.Key ? this.selected : this.selected.map(s => this.getValue(s))

      this.onChange(data);

      this.selectionChange.emit(data);
    }
    this.ngControl.control?.markAllAsTouched();
    if (this.searchValue) {
      this.searchValue = '';
      this.searchList('', this.list);
    }
  }
  selectionIncluded(key: string) {
    if (this.multiple)
      return this.selected?.find((s: any) => s == key) ? true : false;
    else return key == this.selected;
  }

  close() {
    ((this.ngControl?.control) as AbstractControl).markAsTouched();

    this.iTrigger()?.close();
  }

  searchList(e: any, array: any) {
    this.tempList = this.list.filter(s => (this.searchFields?.length ? this.searchFields.map(f => s?.[f] ?? '').join(' ') : JSON.stringify(s)).toLowerCase().includes(e.toLowerCase()));
  }

  logData(e: any) {
    //console.log(e);

  }

  getValue(value: any) {
    if (!value)
      return;
    return this.list?.find(s => s[this.key()] == value);
  }

  getValues(values: any[]) {
    if (!values?.length)
      return;
    return this.list?.filter(s => values.find(x => s[this.key()] == x));
  }



  get dir() {
    return document.body.dir;
  }


  handleOpenMenu() {
    if (this.iTrigger()?.isOpen() && this.selected)
      if (document.getElementById(this.selected))
        document.getElementById(this.selected)?.scrollIntoView({ behavior: 'auto', block: 'start' });

    setTimeout(() => {
      this.searchBox()?.nativeElement.focus();
    }, 100);
  }

  selectAll() {
    if (this.selected.length < this.list.length)
      this.selected = [...this.list.map(o => o[this.key()])]

    else {
      this.selected = [];
    }
    this.emitSelected();
  }

  private emitSelected() {
    const data = this.objectShape() == ReturnedDataShape.Key ? this.selected : this.selected.map(s => this.getValue(s));
    this.onChange(data);

    this.selectionChange.emit(data);
  }

  translate(key: string) {

    console.log(this.language());

    return this.localize(key, this.language(), this.ModuleNames.Shared);
  }

}
